import { createApp } from 'vue'

import App from './App.vue'
import router from './router';
import ElementPlus from 'element-plus';
import store from './store';
import 'element-plus/dist/index.css';
import * as ElIcons from '@element-plus/icons-vue';
import VMdEditor from '@kangc/v-md-editor/lib/codemirror-editor';
// import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/codemirror-editor.css';

import Codemirror from 'codemirror';
import 'codemirror/mode/markdown/markdown';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/vue/vue';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/closetag';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/selection/active-line';
import 'codemirror/addon/scroll/simplescrollbars';
import 'codemirror/addon/scroll/simplescrollbars.css';
import 'codemirror/lib/codemirror.css';

import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';

// highlightjs
import hljs from 'highlight.js';


VMdEditor.Codemirror = Codemirror;

import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
VMdEditor.use(githubTheme, {
    Hljs: hljs,
});

VMdPreview.use(githubTheme, {
    Hljs: hljs,
});




import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/cdn';

VMdEditor.use(createKatexPlugin());


const app = createApp(App);

// 全局注册所有图标
for (const [key, component] of Object.entries(ElIcons)) {
    app.component(key, component);
}
app.use(VMdEditor);
app.use(store);
app.use(VMdPreview);
//const app = createApp(App)
app.use(ElementPlus);
app.use(router);
app.mount('#app')
